'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export const UrlParamsHandler = () => {
  const router = useRouter();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    //Handle ?prompt=xyz & save to local-storage with key 'chat-draft-new'
    const prompt = urlParams.get('prompt');
    if (prompt && prompt.trim() !== '') {
      localStorage.setItem('chat-draft-new', prompt);
      urlParams.delete('prompt');
      const newUrl = window.location.pathname + '?' + urlParams.toString() + window.location.hash;
      router.replace(newUrl);
    }
  }, [router]);

  return null;
};
